import type { JSX } from 'react'
import { cn } from '@/lib/utils'

interface CardProps {
  variant: 'smCard' | 'mdCard'
  children?: React.ReactNode
  title?: string
  description?: React.ReactNode
  icon: JSX.Element | null
  className?: string
  titleClassName?: string
  idSolicitacao?: string
  dateSolicitacao?: string
  status?: string
  statusColor?: string
}
const cardTypes: Record<CardProps['variant'], string> = {
  smCard: 'w-65 h-62 text-sm',
  mdCard: 'w-115 h-100'
}

export const Card = ({
  variant,
  children,
  className,
  title,
  description,
  icon,
  titleClassName,
  idSolicitacao,
  dateSolicitacao,
  status,
  statusColor
}: CardProps) => {
  const cardClass = cardTypes[variant] || cardTypes.mdCard

  return (
    <div
      className={`${cardClass} ${className} border border-[var(--brand-blue-3)] rounded-2xl shadow-xl flex flex-col items-center`}
    >
      {title && icon && (
        <>
          <div className="mt-10">{icon}</div>
          <h1
            className={`text-2xl font-bold p-2 text-[var(--brand-blue-5)] text-center ${titleClassName}`}
          >
            {title}
          </h1>
        </>
      )}
      {idSolicitacao && <p className="text-xs mb-2">{idSolicitacao}</p>}
      {description && (
        <p className={`${className} px-4 py-4 text-center w-87`}>
          {description}
        </p>
      )}
      {dateSolicitacao && <p className="text-base">{dateSolicitacao}</p>}
      {children}
      {status && (
        <p
          className={cn(
            'text-xs text-center mt-2 text-orange-400 font-bold',
            statusColor
          )}
        >
          {status}
        </p>
      )}
    </div>
  )
}
